import { useState } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { UnifiedHeader } from './UnifiedHeader';
import { Sidebar } from './Sidebar';
import { useAuthStore } from '@/store/authStore';
import { useTheme } from '@/app/providers';
import { useMediaQuery } from '@/hooks/useMediaQuery';

const { Content } = Layout;

export const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const { user } = useAuthStore();
  const { theme } = useTheme();
  const isMobile = useMediaQuery('(max-width: 992px)');

  const isDark = theme === 'dark';

  const handleDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  return (
    <Layout className="min-h-screen">
      <Sidebar
        collapsed={collapsed}
        onCollapse={setCollapsed}
        userRole={user?.role}
        isMobile={isMobile}
        mobileDrawerOpen={mobileDrawerOpen}
        onMobileDrawerClose={handleDrawerClose}
      />

      <Layout style={{ marginLeft: isMobile ? 0 : collapsed ? 80 : 260, transition: 'all 0.2s' }}>
        <UnifiedHeader onMenuClick={() => setMobileDrawerOpen(true)} isMobile={isMobile} />

        <Content
          style={{
            background: isDark ? '#0f172a' : '#f5f7fa',
            minHeight: 'calc(100vh - 128px)',
            display: 'flex',
            flexDirection: 'column',
            padding: isMobile ? '16px' : '24px 32px',
          }}
        >
          <div style={{ flex: 1 }}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};
